import { MapPin } from 'lucide-react';
import { displayTime } from './shared';

export const LOCATION_STATUS = {
  capturee: ['Position capturée', 'text-emerald-800'],
  imprecise: ['Position imprécise (> 200 m)', 'text-amber-800'],
  permission_refusee: ['Accès à la position refusé par le navigateur ou le système', 'text-slate-600'],
  indisponible: ['Position indisponible', 'text-slate-600'],
  non_relevee: ['Position non relevée (choix du salarié)', 'text-slate-600'],
  purgee: ['Position purgée (durée de conservation atteinte)', 'text-slate-500'],
};

const mapUrl = loc => `https://www.openstreetmap.org/?mlat=${loc.lat}&mlon=${loc.lon}#map=17/${loc.lat}/${loc.lon}`;

const Phase = ({ label, loc, id, corrected, missing }) => {
  if (!loc) return missing ? <li data-testid={id}><span className="font-medium">{label}</span> <span className="text-slate-600" data-testid={`${id}-status`}>{missing}</span></li> : null;
  const [text, color] = LOCATION_STATUS[loc.status] || [loc.status, 'text-slate-600'];
  const hasCoords = loc.lat !== undefined && loc.lat !== null;
  return <li className="flex flex-wrap gap-x-2 items-center" data-testid={id}>
    <span className="font-medium">{label}</span>
    <span>{displayTime(loc.captured_at || loc.pointing_at)}</span>
    <span className={color} data-testid={`${id}-status`}>{text}{hasCoords && ` · ±${Math.round(loc.accuracy_m)} m`}</span>
    {loc.detail && <span className="text-slate-500">({loc.detail})</span>}
    {hasCoords && <a className="underline" href={mapUrl(loc)} target="_blank" rel="noopener noreferrer" data-testid={`${id}-map`} title="Ouvre OpenStreetMap dans un nouvel onglet et lui transmet ces coordonnées">Voir sur la carte</a>}
    {hasCoords && <span className="text-slate-400">(transmet les coordonnées à OpenStreetMap)</span>}
    {corrected && <span className="text-slate-500" data-testid={`${id}-corrected`}>position d’origine, capturée à l’heure indiquée (horaires corrigés depuis)</span>}
  </li>;
};

export const EntryLocation = ({ entry, showMissing = false }) => {
  const history = entry.end_location_history || [];
  if (!showMissing && !entry.start_location && !entry.end_location && !history.length) return null;
  const corrected = (entry.history || []).some(e => ['admin_correction', 'service_reopened'].includes(e.action));
  const id = `entry-location-${entry.entry_id}`;
  return <div className="text-xs text-slate-700 space-y-1" data-testid={id}>
    <p className="flex items-center gap-1 text-slate-500"><MapPin className="w-3 h-3" />Position fournie par l’appareil — ne constitue pas une preuve certaine de présence.</p>
    <ul className="space-y-1 pl-4">
      <Phase label="Début ·" loc={entry.start_location} id={`${id}-start`} corrected={corrected} missing={showMissing ? 'Aucune position enregistrée' : null} />
      {history.map((loc, i) => <Phase key={i} label={`Fin précédente (clôture ${displayTime(loc.closed_at)}) ·`} loc={loc} id={`${id}-end-prev-${i}`} />)}
      <Phase label="Fin ·" loc={entry.end_location} id={`${id}-end`} corrected={corrected} missing={showMissing ? (entry.ended_at ? 'Aucune position enregistrée' : 'Prestation en cours — fin non pointée') : null} />
    </ul>
  </div>;
};
